import styled from 'styled-components'

export const TitleDecorators = styled.div<{ open: boolean }>`
  margin-bottom: 20px;
  margin-top: -10px;
  display: -webkit-box;
  width: 100%;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 20px;

  ${({ open }) =>
    !open &&
    `
    @media (max-width: 768px) {
      > div:nth-child(n+5) {
        display: none;
      }
    }
  `}
`
export const SeeMore = styled.span`
  font-size: 13px;
  font-weight: var(--font-bold);

  @media (min-width: 768px) {
    display: none;
  }
`

export const WaveContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: ${({ theme }) => theme?.banner?.colour || 'var(--brand-primary)'};
  width: 100%;
  height: 50vh;
  z-index: 0;

  @media (max-width: 768px) {
    height: 380px;

    > div {
      display: none;
    }
  }
`
export const TourInfo = styled.div`
  margin-bottom: 24px;
  font-weight: var(--font-light);
  display: flex;
  justify-content: space-between;

  & a {
    color: var(--brand-secondary);
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`
export const TourRegion = styled.div``
export const TourBadges = styled.div`
  display: flex;
`
export const TourBadge = styled.div`
  display: flex;
  align-items: center;
  font-weight: var(--font-light);

  &:not(:last-child) {
    margin-right: 10px;
  }
`
export const ReviewContainer = styled.div`
  display: flex;
  align-items: center;
`
export const RatingScore = styled.span`
  font-size: 20px;
  margin-left: 4px;
`
export const ReviewCounter = styled.span`
  font-weight: var(--font-light);
  text-decoration: underline;
  margin-left: 26px;
  cursor: pointer;
  font-size: 14px;
`
export const Highlights = styled.div`
  display: grid;
  grid-template-columns: fit-content(400px) fit-content(400px);
  grid-column-gap: 50px;
  grid-row-gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`
export const Highlight = styled.div`
  display: flex;
  align-items: center;
  font-weight: var(--font-regular);
  line-height: 22px;

  & > svg {
    margin-right: 12px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    & > svg {
      width: 34px;
      height: 34px;
    }
  }
`
export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 70%) minmax(0, 30%);
  grid-column-gap: 50px;

  @media (max-width: 1024px) {
    grid-template-columns: 100%;
  }
`
export const Left = styled.div``
export const Right = styled.div`
  @media (max-width: 1024px) {
    grid-row: 1;
    margin-bottom: 64px;
  }
`
export const StickyContainer = styled.div`
  position: sticky;
  position: -webkit-sticky;
  top: 150px;

  & > p {
    margin-top: 10px;
    text-align: left;
    color: var(--sale);
    padding: 10px 0;
  }
  & > p > svg {
    margin-right: 10px;
    margin-bottom: -2px;
  }

  .hot-deal-wrapper {
    margin-bottom: 12px;
    padding: 0 0 12px 0;
    border-bottom: 2px solid #ffefec;
    border-radius: 4px;
  }
`
export const PricingButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 15px;

  > button {
    min-width: calc(50% - 7.5px);
    box-sizing: border-box;
    flex-grow: 1;
    padding: 15px 10px;
  }

  @media (min-width: 1000px) {
    flex-direction: row-reverse;
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    gap: 8px;

    > button {
      width: 100%;
    }
  }
`
export const PricingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`
export const FromPrice = styled.div`
  color: var(--brand-secondary);
  font-size: 14px;
  font-weight: var(--font-medium);
  margin-bottom: 6px;

  & > span {
    text-decoration: line-through;
  }
`
export const Price = styled.span`
  font-weight: var(--font-bold);
  font-size: 30px;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 26px;
  }
`
export const Currency = styled.span`
  font-size: 12px;
  font-weight: var(--font-bold);
`
export const MoreToExplore = styled.div`
  background: var(--grey-25);
`
export const MoreToExploreWrapper = styled.div`
  max-width: 1224px;
  margin: 0 auto;
  padding: 0 100px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`

export const TopSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`

export const MobileBookNow = styled.div<{ active: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 3;
  background: white;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  transform: translateY(100%);
  transition: 0.25s ease-in-out;
  display: none;
  opacity: 0;

  @media (max-width: 767px) {
    display: flex;
  }

  ${({ active }) =>
    active &&
    `
    transform: translateY(0);
    opacity: 1;
  `}
`

export const PricingWrapper = styled.div<{ onSale: boolean }>`
  ${({ onSale }) =>
    onSale &&
    `
    ${Price},
    ${Currency} {
      color: var(--sale);
    }
  `}
`

export const NZRiskDisclosureText = styled.div`
  text-decoration: underline;
  cursor: pointer;
`

export const ExperienceVoucherBanner = styled.div<{ $backgroundColor: string; $color: string; $borderColor: string }>`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  padding: 12px 20px;
  border-radius: 6px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border: 1px solid ${({ $backgroundColor }) => $backgroundColor};
  box-sizing: border-box;
  align-items: center;
  color: ${({ $color }) => $color};

  svg {
    fill: white;
    height: 24px;
  }
`

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
`
